import { render, staticRenderFns } from "./InputworkhourPage.vue?vue&type=template&id=2326d28c"
import script from "./InputworkhourPage.vue?vue&type=script&lang=js"
export * from "./InputworkhourPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports